export default __webpack_public_path__ + "static/media/d16.68cadee8.jpeg";